import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
 
@Injectable({ providedIn: "root" })
export class NavigationService {
  langCode;

  constructor(private router: Router) {}

  back(): void {
    this.langCode = localStorage.getItem("langCode")
      ? localStorage.getItem("langCode")
      : "en";

    if (location.href.includes("home")) {
      this.router.navigate([this.langCode]);
    } else {
      let url = location.pathname;
      let urlPathArray = url.split("/");
      let gameGroup = urlPathArray[urlPathArray.length - 1];
      let redirectUrl = url.replace("/" + gameGroup, "");
      this.router.navigateByUrl(redirectUrl);
    }
  }
}